import React from 'react';
import { Card, Button, Table, List, Grid, Row, Col } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

const { useBreakpoint } = Grid;

export default function ItemsTableSection({
  columns,
  invoiceItems,
  addItem,
}) {
  const screens = useBreakpoint();

  const renderMobileItem = (item) => {
    const productCol = columns.find(c => c.key === 'product');
    const quantityCol = columns.find(c => c.key === 'quantity');
    const priceCol = columns.find(c => c.key === 'price');
    const amountCol = columns.find(c => c.key === 'amount');
    const actionsCol = columns.find(c => c.key === 'actions');

    return (
      <Card size="small" style={{ marginBottom: '8px' }} styles={{ body: { padding: '8px' } }}>
        <div style={{ marginBottom: '8px' }}>
          <div style={{ fontSize: '11px', color: '#8c8c8c', marginBottom: '2px' }}>{productCol.title}</div>
          {productCol.render(null, item)}
        </div>
        
        <Row gutter={8} style={{ marginBottom: '8px' }}>
          <Col span={12}>
            <div style={{ fontSize: '11px', color: '#8c8c8c', marginBottom: '2px' }}>{quantityCol.title}</div>
            {quantityCol.render(item.quantity, item)}
          </Col>
          <Col span={12}>
            <div style={{ fontSize: '11px', color: '#8c8c8c', marginBottom: '2px' }}>{priceCol.title}</div>
            {priceCol.render(item.price, item)}
          </Col>
        </Row>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderTop: '1px solid #f0f0f0', paddingTop: '8px' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <span style={{ fontSize: '12px', fontWeight: 'bold', marginRight: '4px' }}>Total:</span>
            {amountCol.render(null, item)}
          </div>
          <div>
            {actionsCol.render(null, item)}
          </div>
        </div>
      </Card>
    );
  };

  return (
    <Card title="Productos y Servicios" size="small" style={{ marginBottom: '12px' }} styles={{ body: { padding: '12px' } }}>
      <div style={{ marginBottom: '8px' }}>
        <Button
          type="dashed"
          onClick={addItem}
          icon={<PlusOutlined />}
          size="small"
          style={{ width: '100%' }}
        >
          Agregar Producto
        </Button>
      </div>

      {screens.xs ? (
        <List
          dataSource={invoiceItems}
          locale={{ emptyText: 'No hay productos agregados' }}
          renderItem={renderMobileItem}
          split={false}
        />
      ) : (
        <Table
          columns={columns}
          dataSource={invoiceItems}
          pagination={false}
          size="small"
          scroll={{ x: 'max-content' }}
          locale={{ emptyText: 'No hay productos agregados' }}
        />
      )}
    </Card>
  );
}